import {Component, EventEmitter, Input, OnInit, Output, Renderer2, OnDestroy} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-summary-counts-redirect',
  template:  `<a *ngIf = "isClickable" href="#" (click)="onClick()" >{{renderValue}}</a><span *ngIf = "!isClickable">{{renderValue}}</span>`,
  styleUrls: ['./summary-counts-redirect.component.scss']
})
export class SummaryCountsRedirectComponent implements OnInit {
    
    isClickable: boolean = false;
    renderValue: string | number;
    @Input() value: any;
    @Input() rowData: any;
    @Output() clicked: EventEmitter<any> = new EventEmitter();

    constructor( ) {
    }

    ngOnInit() {
      // console.log( " TableStatusComponent -> value ", this.value )
      // console.log( " TableStatusComponent -> rowData ", this.rowData )
      //this.isClickable = ( ( parseFloat( this.value ) > 0 ) ? true : false );
      this.renderValue = this.value;
    }
  
    onClick() {
      this.clicked.emit(this.rowData);
      return false;
    }

}
